import { Link, navigate } from 'gatsby'
import { GatsbyImage, getImage } from 'gatsby-plugin-image'
import React from 'react'
import alt from '../content/alt'
import { colors, alpha, s, grid, sTextGradient } from '../style'

const Tile = ({ data, small, large, subtitleOnTop, slider }) => {
  const { name, slug, image, subtitle, backgroundText, icon, action, url } =
    data

  const newSlug = slug ? `/${slug}/` : url

  return (
    <div css={[sOuter, small && sOuterSmall, slider && sOuterSlider]}>
      <div
        css={[
          sContainer,
          small && sContainerSmall,
          large && sContainerLarge,
          slider && sContainerSlider,
          subtitleOnTop && sContainerNoTextAniimation,
        ]}
        onClick={() => {
          navigate(newSlug)
          if (action) action()
        }}
        onKeyPress={() => {
          navigate(newSlug)
          if (action) action()
        }}
        role='link'
        tabIndex={0}>
        <GatsbyImage
          className='image'
          image={getImage(image)}
          alt={name + alt}
          style={sImageStyle}
          imgStyle={sImageImgStyle}
        />
        <div css={sDimmer} className='dimmer' />
        {backgroundText && (
          <>
            <div css={sBackgroundText} className='back-text'>
              {backgroundText}
            </div>
            <div css={sBackgroundText} className='back-text'>
              {backgroundText}
            </div>
            {/* <div css={sBackgroundText}>{backgroundText}</div> */}
          </>
        )}

        {icon && (
          <>
            <div css={sBackgroundIcon} className='back-icon'>
              {icon()}
            </div>
            <div css={sBackgroundIcon} className='back-icon2'>
              {icon()}
            </div>
          </>
        )}

        <Link to={newSlug} css={sLink}>
          {subtitleOnTop && (
            <span
              css={[sSubtitle, { fontSize: '0.875rem' }]}
              className='subtitle-ontop'>
              {subtitle}{' '}
            </span>
          )}
          {name}{' '}
          {subtitle && !subtitleOnTop && (
            <span css={sSubtitle} className='subtitle'>
              {subtitle}
            </span>
          )}
        </Link>
      </div>
    </div>
  )
}

const sOuter = {
  padding: '1rem',
  [s.xs]: {
    maxWidth: grid(12),
    flexBasis: grid(12),
    padding: '0rem 0rem 1rem',
  },
  [s.sm]: {
    maxWidth: grid(12),
    flexBasis: grid(12),
  },
  [s.md]: {
    maxWidth: grid(4),
    flexBasis: grid(4),
  },
}

const sOuterSmall = {
  [s.xs]: {
    maxWidth: grid(12),
    flexBasis: grid(12),
    padding: '0rem 0rem 1rem',
    // '&:nth-of-type(2n)': {
    //   paddingLeft: '0.5rem',
    // },
    // '&:nth-of-type(2n + 1)': {
    //   paddingRight: '0.5rem',
    // },
  },
  [s.sm]: {
    maxWidth: grid(6),
    flexBasis: grid(6),
  },
  [s.md]: {
    maxWidth: grid(3),
    flexBasis: grid(3),
  },
}

const sOuterSlider = {
  padding: 0,
  maxWidth: 'unset',
  width: '100%',
  [s.sm]: {
    maxWidth: 'unset',
    // flexBasis: 'unset',
  },
  [s.md]: {
    maxWidth: 'unset',
    // flexBasis: 'unset',
  },
}

const sContainer = {
  backfaceVisibility: 'hidden',
  transform: 'translate3d(0, 0, 0)',
  fontSize: '1.25rem',
  cursor: 'pointer',
  position: 'relative',
  top: 0,
  left: 0,
  backgroundColor: colors.greyDark,
  padding: '2rem 2rem',
  borderRadius: '1rem',
  color: 'white',
  height: '100%',
  display: 'flex',
  // alignItems: 'flex-end',
  justifyContent: 'flex-end', // is it ok?
  flexDirection: 'column', // is it ok?
  overflow: 'hidden',
  minHeight: '10rem',
  [s.xs]: {
    padding: '2rem 2rem',
  },
  '&:hover': {
    [s.hover]: {
      '.image': {
        transform: 'scale(1.25) !important',
        filter: 'brightness(1.1)',
      },
      a: {
        transform: 'scale(0.9)',
        textShadow: `4px 4px 16px ${colors.text}`,
      },
      '.subtitle': {
        // transform: 'scale(1.5) translateX(16.6%)',
        opacity: 1,
      },
      '.dimmer': {
        opacity: 0.5,
      },
    },
  },

  // '.gatsby-image-wrapper': {
  //   backfaceVisibility: 'hidden',
  //   transform: 'translate3d(0, 0, 0)',
  //   overflow: 'hidden',
  // },
}

const sContainerNoTextAniimation = {
  '&:hover': {
    a: {
      transform: 'none',
    },
  },
}

const sContainerSmall = {
  // fontSize: '1.25rem',
  minHeight: '8rem',

  [s.xs]: {
    minHeight: '4rem',
    padding: '2rem 2rem',
  },
}

const sContainerSlider = {
  minHeight: '10rem',
}

const sContainerLarge = {
  [s.sm_only]: {
    '.back-text': {
      fontSize: '8rem',
    },
  },
  '.back-text': {
    lineHeight: '1em',
  },
  '.back-icon2': {
    opacity: 0,
  },
  '&:hover': {
    a: {
      [s.sm_down]: {
        transform: 'none',
      },
    },
    [s.hover]: {
      a: {
        textShadow: 'none',
        transform: ' scale(1.5)',
        opacity: 1,
        // mixBlendMode: 'normal',
        // background: 'white',
        // WebkitBackgroundClip: 'text',
        // WebkitTextFillColor: 'transparent',
        [s.sm_down]: {
          transform: 'none',
        },
      },
      '.back-text': {
        transform: 'translate(-50%, -50%) scale(2)',
        opacity: 0,
      },
      '.back-icon': {
        transform: 'translate(-50%, -50%) scale(2)',
        opacity: 0,
      },
      '.back-icon2': {
        opacity: 1,
        mixBlendMode: 'normal',
        transform: 'translate(-50%, -50%) scale(0.5)',
      },
    },
  },
  [s.md]: {
    borderRadius: '1.5rem',
    minHeight: '30rem',
    // justifyContent: 'center',
    alignItems: 'center',
    textShadow: 'none',
    a: {
      position: 'relative',
      top: 0,
      left: 0,
      zIndex: 20,

      fontWeight: 900,
      width: 'max-content',
      // fontSize: '1.5rem',
      // opacity: 0.6,
      // mixBlendMode: 'overlay',
      padding: '2rem',
      textAlign: 'center',
      // textTransform: 'uppercase',
      // letterSpacing: '0.1em',
      '@media screen and (-webkit-min-device-pixel-ratio:0) and (min-resolution:.001dpcm)':
        {
          a: {
            ...sTextGradient,
          },
        },
    },
  },
  zIndex: 10,
  backfaceVisibility: 'hidden',
  transform: 'translate3d(0, 0, 0)',
}

const sBackgroundText = {
  ...sTextGradient,
  transition: 'transform 0.2s ease-out, opacity 0.15s ease-out',
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  fontSize: '16rem',
  mixBlendMode: 'overlay',
  zIndex: 90,

  pointerEvents: 'none',
  [s.xs]: {
    // fontWeight: 700,
    fontSize: '10rem',
    transform: 'translate(0%, -50%)',
    left: 18,
    // right: '2rem',
  },
}

const sBackgroundIcon = {
  transition: 'transform 0.2s ease-out, opacity 0.15s ease-out',
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: '8rem',
  height: '8rem',
  mixBlendMode: 'overlay',
  zIndex: 90,
  pointerEvents: 'none',
  [s.xs]: {
    transform: 'translate(0%, 0%)',
    top: '2rem',
    left: '2rem',
    width: '4rem',
    height: '4rem',
  },
}

const sLink = {
  fontWeight: 700,
  letterSpacing: '-0.05em',
  position: 'relative',
  top: 0,
  left: 0,
  zIndex: 2,
  transition: 'all 0.2s ease-in-out',
  display: 'flex',
  flexDirection: 'column',
  // ...sTextGradient,
  // background: `linear-gradient(to right, ${colors.white.concat(
  //   alpha[60]
  // )}, ${colors.white.concat(alpha[100])})`,
}

const sImageStyle = {
  width: '100%',
  height: '100%',
  position: 'absolute',
  top: 0,
  right: 0,
  transition: 'all 0.2s ease-in-out',
  borderRadius: 'inherit',
  transform: 'translate3d(0,0,0)',
  // backfaceVisibility: 'hidden',
  // overflow: 'hidden',
  // zIndex: -1,
  zIndex: 0,
}

const sImageImgStyle = {
  objectFit: 'cover',
  objectPosition: 'center center',
  // zIndex: -1,
  // overflow: 'hidden',
  // transform: 'translate3d(0,0,0)',
  // backfaceVisibility: 'hidden',
  zIndex: 0,
}

const sDimmer = {
  borderRadius: 'inherit',
  position: 'absolute',
  top: 0,
  left: 0,
  width: '100%',
  height: '100%',
  background: `linear-gradient(to top right, 
    ${colors.greyDarker} 0%, 
    ${colors.greyDarker.concat(alpha[90])} 15%, 
    ${colors.greyDarker.concat(alpha[60])} 50%,  
    ${colors.greyDarker.concat(alpha[0])} 85%,  
      ${colors.greyDarker.concat(alpha[0])} 100%)`,
  transition: 'opacity 0.2s ease-in-out',
}

const sSubtitle = {
  // textTransform: 'uppercase',
  opacity: 0.6,
  fontSize: '0.75rem',
  // letterSpacing: '0.05em',
  fontWeight: 700,
  marginTop: '0.5rem',
  transition: 'all 0.2s ease-in-out',
}

export default Tile
